import logoLong from '../../assets/diligenshub-logo.svg';
import { Container } from '../site/Sections';
import { LOGIN_URL, SITE_URL, sitePath } from '../../lib/links';
import * as copy from '../../content/status';

// The frame around the status page on status.diligenshub.com: the logo, the
// two links people need when something is wrong, and the legal links. Every
// link is absolute to the site, because on this host every path is the
// status page (App.js).
const linkClass = 'text-sm font-medium text-neutral-600 hover:text-primary-900 transition-colors duration-150';
const footLinkClass = 'text-sm text-primary-200 hover:text-white transition-colors duration-150';

export const StatusShell = ({ children }) => (
  <div className="flex min-h-screen flex-col">
    <header className="border-b border-neutral-200 bg-white" data-testid="status-header">
      <Container className="flex h-16 items-center justify-between gap-4">
        <a href={SITE_URL} className="flex items-center gap-3">
          <img src={logoLong} alt="DiligensHub" className="h-7 w-auto" />
          <span className="hidden border-l border-neutral-200 pl-3 text-sm font-medium text-neutral-500 sm:inline">Status</span>
        </a>
        <nav className="flex items-center gap-5">
          <a href={sitePath('/support')} className={linkClass}>
            Support
          </a>
          <a href={LOGIN_URL} className={linkClass}>
            Log In
          </a>
        </nav>
      </Container>
    </header>
    <main className="flex-1">{children}</main>
    <footer className="bg-primary-900" data-testid="status-footer">
      <Container className="flex flex-col gap-4 py-8 sm:flex-row sm:items-center sm:justify-between">
        <p className="text-sm text-primary-300">© {new Date().getFullYear()} DiligensHub</p>
        <nav aria-label="Legal" className="flex flex-wrap gap-x-6 gap-y-2">
          <a href={sitePath('/privacy')} className={footLinkClass}>
            Privacy
          </a>
          <a href={sitePath('/terms')} className={footLinkClass}>
            Terms
          </a>
          <a href={SITE_URL} className={footLinkClass}>
            {copy.footer.site}
          </a>
        </nav>
      </Container>
    </footer>
  </div>
);

export default StatusShell;
